<template>

<div>
    
<div style="text-align:right" >
<el-dropdown
>
  <el-button type="primary">
    How much do you want?<i class="el-icon-arrow-down el-icon--right"></i>
  </el-button>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item @click.native="getQrCodes(20)" > 20</el-dropdown-item>
    <el-dropdown-item @click.native="getQrCodes(40)" > 40</el-dropdown-item>
    <el-dropdown-item @click.native="getQrCodes(60)" > 60</el-dropdown-item>
    <el-dropdown-item @click.native="getQrCodes(80)" > 80</el-dropdown-item>
    <el-dropdown-item @click.native="getQrCodes(100)" > 100</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
</div>

<div style="text-align:center; margin: 25px">

    <h2> Print QR code stickers, put them on any of your machines, and scan it when you add the machine </h2>
    <h3> Then just scan the QR from the machine anytime, and it will automatically take you inside this machine page.</h3>

       <el-button size="medium" @click.native="print()" type="success">Print sheet</el-button>
       <p> Currently working with Chrome, Firefox and Opera.</p>

    </div>

<div class="qr-on-screen">
  <div class="qr-code-parent" v-for="qrcode in this.QrArray" :key="qrcode.QrLink">
   <div class="flex">
    <qrcode-vue class="qr-code" :value="qrcode.QrLink " :size="size" level="H"></qrcode-vue>

    <div class="qr-code-info">
      <div class="logo-wrapper">
        <img class="logo" src="@/assets/new-logo.jpg" alt="logo">
      </div>
      <p class="upper-text"> Scan to view asset.</p>
      <p class="bottom-text"> Managed by JoBase</p>
    </div>
   </div>

  </div>
  </div>

</div>

</template>
<script>
import QrcodeVue from 'qrcode.vue'
import { v4 as uuidv4 } from 'uuid';

export default {

components: {
    QrcodeVue,
},

data() {
    return {
    QrArray: [],
    size: 110,
    }
},
methods:{

getQrCodes(number) { 
    if(number == undefined){
        number = 10;
    }
     
    this.QrArray = [];

    for( var i=0; i < number; i++){
    var uniqueQrCode = {
                QrLink: process.env.VUE_APP_BASE_URL + "/qr/" + uuidv4(),
    }
    this.QrArray.push(uniqueQrCode);
    }

    },
      print() {

          var qrOnScreen = document.getElementsByClassName("qr-on-screen")[0];

          qrOnScreen.classList.add("qr-to-print");

          qrOnScreen.classList.remove("qr-on-screen");

            // var x = window.matchMedia("(max-width: 979px)");

            // if (x.matches) {

            //    var qr = document.getElementsByClassName("qr-code")[0];
            //    qr.classList.remove("qr-code");
            //    qr.classList.add("qr-print-mobile");

            //   }

          window.print();

          var qrToPrint = document.getElementsByClassName("qr-to-print")[0];

          qrToPrint.classList.add("qr-on-screen");

          qrToPrint.classList.remove("qr-to-print");

        //    if (x.matches) {

        //        var qr = document.getElementsByClassName("qr-print-mobile")[0];
        //        qr.classList.add("qr-code");
        //        qr.classList.remove("qr-print-mobile");

        //       }

    //   var prtContent = document.getElementById("print");
    //   var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    //   WinPrint.document.write(prtContent);
    //   WinPrint.document.close();
    //   WinPrint.focus();
    //   WinPrint.print();
    //   WinPrint.close();
     }
},
mounted(){
      this.getQrCodes();
},


  }
</script> 
<style scoped>

.qr-on-screen{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    width: 90vw;
    max-width: 800px;
    text-align: center;
    margin: auto;
    margin-top: 50px;
    background: white;
}

.qr-code-parent{
    display:inline-block;
    margin: 37px 30px;
}

.qr-code{
  display: inline-block;
}

.flex{
  display: flex;
}

.qr-code-info{
  display: inline-block;
  vertical-align: bottom;
  margin: 12px;
  margin-left: 15px;
  margin-top: 0px;
}

.logo-wrapper{
    max-height: 71px;
    height: 80px;
    margin-top: -12px;
    overflow: hidden;
}

.logo{
  height: 80px;
}

.qr-to-print{
    position: absolute;
    text-align: center;
    margin-top: -250px;
    padding-top: 37px;
    background-color: white;
    z-index: 10;
}

.upper-text{
    margin: 6px;
    font-size: 15px;
}

.bottom-text{
     margin: 0px;
    font-size: 9px;
}

qr-print-mobile{
     display:inline-block;
     margin: 15px;
}

@media  (max-width: 979px) {

    .qr-on-screen{
     width: 100%;
    }

}


@media print{
  body{
 margin: 0px;
 padding: 0px;
 border: 0px;
  }
}

</style>